module.exports = __webpack_public_path__ + "img/ring_g_l_null_0@2x.d027b7e9.png";